var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useEffect, useState } from 'react';
import { CONDITION_FILTER_OPTIONS, CONDITION_FILTERS_OPERATOR_MAP, OPERATORS_CONDITION_FILTERS_MAP, } from '../constants/types';
import { FlightOverflowMenu, FlightTextInput } from '@flybits/design-system';
import { getLogicStringOperator, getLogicStringTokens, translateLogicString } from '../UIJsonParser/transformations';
var RuleCondition = function (props) {
    var MAIN_CLASS = 'rule-condition';
    var conditionString = props.conditionString, isExpandAll = props.isExpandAll, onExpandToggleClick = props.onExpandToggleClick, onChangeConditionKey = props.onChangeConditionKey, onError = props.onError, isCustomLogic = props.isCustomLogic, setIsCustomLogic = props.setIsCustomLogic, setUiModel = props.setUiModel, uiBlocks = props.uiBlocks;
    var _a = __read(useState(''), 2), conditionInput = _a[0], setConditionInput = _a[1];
    var _b = __read(useState(''), 2), conditionStringLabel = _b[0], setConditionStringLabel = _b[1];
    var _c = __read(useState(false), 2), conditionStringHasError = _c[0], setConditionStringHasError = _c[1];
    var _d = __read(useState(''), 2), conditionStringErrorMsg = _d[0], setConditionStringErrorMsg = _d[1];
    var _e = __read(useState('checkboxCheck'), 2), conditionStringTrailingIcon = _e[0], setConditionStringTrailingIcon = _e[1];
    var _f = __read(useState(true), 2), disableLogicInput = _f[0], setDisableLogicInput = _f[1];
    var handleFilterClick = function (key) {
        setConditionStringLabel(key);
        if (key === CONDITION_FILTER_OPTIONS.CUSTOM) {
            setUiModel(function (oldModel) { return (__assign(__assign({}, oldModel), { metadata: JSON.stringify({ isCustomLogic: true }) })); });
            setIsCustomLogic(true);
        }
        else {
            setUiModel(function (oldModel) { return (__assign(__assign({}, oldModel), { metadata: JSON.stringify({ isCustomLogic: false }) })); });
            setIsCustomLogic(false);
            onChangeConditionKey(CONDITION_FILTERS_OPERATOR_MAP[key]);
        }
    };
    // dunno if onBlur is the right place for this but w/e for now
    var handleBlur = function () {
        if (conditionInput.length < 1) {
            setConditionStringHasError(true);
            setConditionStringErrorMsg('Missing condition logic');
            setConditionStringTrailingIcon('error');
        }
        // Disabling validation for now as the logic needs to be updated
        // based on location groups and custom logic string
        // else {
        //   if (validateLogicString(conditionString, predicateCount)) {
        //     setConditionStringHasError(false);
        //     setConditionStringErrorMsg('');
        //     setConditionStringTrailingIcon('checkboxCheck');
        //   } else {
        //     setConditionStringHasError(true);
        //     setConditionStringErrorMsg('Invalid boolean logic');
        //     setConditionStringTrailingIcon('error');
        //   }
        // }
        setUiModel(function (oldModel) { return (__assign(__assign({}, oldModel), { condition: translateLogicString(conditionInput, uiBlocks, true) })); });
        setConditionInput(function (prev) { return prev.trim(); });
    };
    var conditionFilterOptions = [
        [
            {
                key: CONDITION_FILTER_OPTIONS.ALL,
                name: 'All',
                disabled: isCustomLogic,
                onClick: function () {
                    setDisableLogicInput(true);
                    handleFilterClick(CONDITION_FILTER_OPTIONS.ALL);
                },
            },
            {
                key: CONDITION_FILTER_OPTIONS.ANY,
                name: 'Any',
                disabled: isCustomLogic,
                onClick: function () {
                    setDisableLogicInput(true);
                    handleFilterClick(CONDITION_FILTER_OPTIONS.ANY);
                },
            },
            {
                key: CONDITION_FILTER_OPTIONS.CUSTOM,
                name: 'Custom',
                onClick: function () {
                    setDisableLogicInput(false);
                    handleFilterClick(CONDITION_FILTER_OPTIONS.CUSTOM);
                },
            },
        ],
    ];
    // honestly this is kinda a stopgap, we should really be rehydrating sparingly
    useEffect(function () {
        if (uiBlocks.length === 0 && conditionString === '') {
            setConditionStringLabel(CONDITION_FILTER_OPTIONS.ALL);
        }
        // prevent custom from being translated when users first switch over
        if (!isCustomLogic || conditionString === conditionInput)
            setConditionInput(translateLogicString(conditionString, uiBlocks));
        if (isCustomLogic) {
            setConditionStringLabel('Custom');
            setDisableLogicInput(false);
        }
        else {
            setConditionStringLabel(OPERATORS_CONDITION_FILTERS_MAP[getLogicStringOperator(getLogicStringTokens(conditionString))]);
            setDisableLogicInput(true);
        }
    }, [isCustomLogic, conditionString, uiBlocks]);
    useEffect(function () {
        onError(conditionStringHasError);
    }, [conditionStringHasError]);
    return (React.createElement("div", { className: conditionStringHasError ? "".concat(MAIN_CLASS, " ").concat(MAIN_CLASS, "--error") : MAIN_CLASS },
        React.createElement("div", { className: "".concat(MAIN_CLASS, "__condition") },
            React.createElement("div", { className: "".concat(MAIN_CLASS, "__condition__msg") }, "The restricted audience must meet "),
            React.createElement(FlightOverflowMenu, { className: "".concat(MAIN_CLASS, "__condition__label"), label: conditionStringLabel, direction: "bottom", isOpenRight: true, iconRight: null, optionGroups: conditionFilterOptions }),
            React.createElement(FlightTextInput, { name: "condition-string", className: conditionStringHasError
                    ? "".concat(MAIN_CLASS, "__condition__string ").concat(MAIN_CLASS, "__condition__string--error")
                    : "".concat(MAIN_CLASS, "__condition__string"), value: conditionInput, hasError: conditionStringHasError, errorMessage: conditionStringErrorMsg, disabled: disableLogicInput, onChange: function (e) {
                    var _a;
                    setConditionInput(((_a = e.target) === null || _a === void 0 ? void 0 : _a.value) || '');
                }, onBlur: handleBlur, trailingIcon: conditionStringTrailingIcon })),
        React.createElement("button", { className: "".concat(MAIN_CLASS, "__condition__expand-toggle-btn"), onClick: function (e) {
                onExpandToggleClick(e);
            } }, !isExpandAll ? 'Expand all' : 'Collapse all')));
};
export default RuleCondition;
//# sourceMappingURL=RuleCondition.js.map